export const LINKS_UTEIS = 'LINKS_UTEIS';
export const LINKS_UTEIS_START = 'LINKS_UTEIS_START';
export const LINKS_UTEIS_SUCCESS = 'LINKS_UTEIS_SUCCESS';
export const LINKS_UTEIS_ERROR = 'LINKS_UTEIS_ERROR';
